module.exports = __webpack_public_path__ + "img/img9.75b2360c.png";